"use client"

import { BatteryPlus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BatteryPlusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BatteryPlusIcon = component(Icon)({ as: BatteryPlus })
